import { useTranslation } from "react-i18next";
import {
    GetSupplier_DeprecatedDocument,
    User,
} from "../../../../generated/client/graphql";
import { useGraphQL } from "../../../QueryClientWithHeaders";
import Container from "../../../components/Container";
import BodyHeader from "../../../shared/components/BodyHeader";

import { usePageviewTrack } from "@app/shared/planhat";
import { useSetAtom } from "jotai";
import { useParams } from "react-router-dom";
import ButtonRegular from "../../../components/Button/ButtonRegular";
import { ButtonType } from "../../../components/Button/ButtonShared";
import { newUsersModalOpenAtom } from "../../Users/components/NewUserModal";
import NewSupplierUserModal from "../../Users/components/NewUserModal/NewSupplierUser";
import { UsersTableInner } from "../../Users/components/UsersTable";
import "./i18n";

export default function Supplier() {
    const { t } = useTranslation("Supplier");
    const { supplier_id } = useParams<{ supplier_id: string }>();
    const getSuppliers = useGraphQL(GetSupplier_DeprecatedDocument, {
        id: supplier_id!,
    });

    const supplier = getSuppliers.data?.supplier;
    const users = supplier?.users;
    const setNewUserModalOpen = useSetAtom(newUsersModalOpenAtom);

    usePageviewTrack("pageview_supplier");

    return (
        <>
            <Container>
                <BodyHeader
                    title={supplier?.name || ""}
                    subTitle={t("subtitle")}
                    // action={<NewSupplierModal refetch={getSuppliers.refetch} />}
                />
                <div className="p-4 space-y-4">
                    {users && (
                        <UsersTableInner
                            supplierMode={true}
                            users={users as User[]}
                        />
                    )}
                    <ButtonRegular
                        variant={ButtonType.OUTLINED}
                        onClick={() => setNewUserModalOpen(true)}
                    >
                        {t("add_user")}
                    </ButtonRegular>
                </div>
            </Container>
            <NewSupplierUserModal
                supplierId={supplier_id}
                onSuccess={getSuppliers.refetch}
            />
        </>
    );
}
